import {Button, Form, Modal} from "semantic-ui-react";
import {useEffect, useState} from "react";
import {useAppDispatch} from "../../app/hooks";
import {CreateNewInvent, UpdateInvent} from "./TablesActions";
import {RootState} from "../../app/store";
import {useSelector} from "react-redux";
import {IInventTable} from "../../interfaces/InventTable";
import {InputEAN} from "./InputEAN";
import { checksum } from "../../utils/checkSumEAN";
import { useTranslation } from "react-i18next";
interface IInventModal {
  open: boolean;
  row: IInventTable;
  updateRow: boolean;
  onClose: () => void;
}

export const InventModal = ({open, row, updateRow, onClose}: IInventModal) => {
  const [newRow, setNewRow] = useState<IInventTable>(emptyRow);
  const dispatch = useAppDispatch();
  const [errors, setErrors] = useState<{[key: string]: string}>({});
  const {companyId} = useSelector((state: RootState) => state.auth);
  const {t} = useTranslation();

  useEffect(() => {
    if (updateRow) {
      setNewRow(row);
    } else {
      setNewRow(emptyRow);
    }
  }, [row, updateRow]);

  const onInputChange = (e: any) => {
    const {name, value} = e.target;
    setErrors({...errors, [name]: ""});
    if (name === "qtyBox" || name === "qtyPallet" || name === "daysBb" || name === "daysExp") {
      if (value !== "" && !isNaN(Number(value))) {
        setNewRow({...newRow, [name]: parseInt(value)});
      } else if (value === "") {
        setNewRow({...newRow, [name]: undefined});
      }
    } else if (name === "netWeight" || name === "bruttoWeight" || name === "bruttoWeightBox" || name === "bruttoWeightPallet") {
      // Allow numbers, '.' and ','
      const regex = /^\d*\.?\d*$|^\d*,?\d*$/;
      if (regex.test(value)) {
        setNewRow({...newRow, [name]: value});
      }
    } else if (name === "ean14" || name === "ean14Box" || name === "ean14Pallet") {
      // Allow 14 numbers
      const regex = /^\d{0,14}$/;
      if (regex.test(value)) {
        setNewRow({...newRow, [name]: value});
      }
    } else {
      setNewRow({...newRow, [name]: value});
    }
  };

  const handleBlur = (e: any) => {
    const {name, value} = e.target;
    if (name === "netWeight" || name === "bruttoWeight" || name === "bruttoWeightBox" || name === "bruttoWeightPallet") {
      const numericValue = value.replace(",", ".");
      if (numericValue !== "" && !isNaN(Number(numericValue))) {
        setNewRow({...newRow, [name]: parseFloat(parseFloat(numericValue).toFixed(3))});
      }
    }
  };

  const validateForm = () => {
    let errors = {};
    if (!newRow.itemId || newRow.itemId.length === 0) {
      errors = {...errors, itemId: t("itemid_empty_err")};
    }
    if (newRow.itemId.length > 20) {
      errors = {...errors, itemId: t("itemid_long_err")};
    }
    if (newRow.itemName && newRow.itemName.length > 50) {
      errors = {...errors, itemName: t("itemname_long_err")};
    }
    if(newRow.ean14 && !checksum(newRow.ean14)){
      errors = {...errors, ean14: t("ean14_invalid_err")};
    }
    if(newRow.ean14Box && !checksum(newRow.ean14Box)){
      errors = {...errors, ean14Box: t("ean14_invalid_err")};
    }
    if(newRow.ean14Pallet && !checksum(newRow.ean14Pallet)){
      errors = {...errors, ean14Pallet: t("ean14_invalid_err")};
    }
    if (newRow.ean14 && newRow.ean14.length !== 14 && newRow.ean14.length !== 8 && newRow.ean14.length !== 13) {
      errors = {...errors, ean14: t("ean14_length_err")};
    }
    if (newRow.ean14Box && newRow.ean14Box.length !== 14 && newRow.ean14Box.length !== 8 && newRow.ean14Box.length !== 13) {
      errors = {...errors, ean14Box: t("ean14_length_err")};
    }
    if (newRow.ean14Pallet && newRow.ean14Pallet.length !== 14 && newRow.ean14Pallet.length !== 8 && newRow.ean14Pallet.length !== 13) {
      errors = {...errors, ean14Pallet: t("ean14_length_err")};
    }
    if (newRow.qtyBox && newRow.qtyBox < 0) {
      errors = {...errors, qtyBox: t("qty_small_err")};
    }
    if (newRow.qtyPallet && newRow.qtyPallet < 0) {
      errors = {...errors, qtyPallet: t("qty_small_err")};
    }
    if (newRow.netWeight && newRow.netWeight < 0) {
      errors = {...errors, netWeight: t("net_weight_small_err")};
    }
    if (newRow.bruttoWeight && newRow.bruttoWeight < 0) {
      errors = {...errors, bruttoWeight: t("brutto_weight_small_err")};
    }
    if (newRow.bruttoWeightBox && newRow.bruttoWeightBox < 0) {
      errors = {...errors, bruttoWeightBox: t("brutto_weight_small_err")};
    }
    if (newRow.bruttoWeightPallet && newRow.bruttoWeightPallet < 0) {
      errors = {...errors, bruttoWeightPallet: t("brutto_weight_small_err")};
    }
    if (newRow.daysBb && newRow.daysBb < 0) {
      errors = {...errors, daysBb: t("days_err")};
    }
    if (newRow.daysExp && newRow.daysExp < 0) {
      errors = {...errors, daysExp: t("days_err")};
    }
    if (newRow.ai90 && newRow.ai90.length > 20) {
      errors = {...errors, ai90: "AI90 " + t("ai_length_err")};
    }
    if (newRow.ai91 && newRow.ai91.length > 20) {
      errors = {...errors, ai91: "AI91 " + t("ai_length_err")};
    }
    if (newRow.ai92 && newRow.ai92.length > 20) {
      errors = {...errors, ai92: "AI92 " + t("ai_length_err")};
    }
    setErrors(errors);

    return Object.keys(errors).length === 0;
  };
  const onSubmit = () => {
    if (validateForm()) {
      if (updateRow) {
        dispatch(UpdateInvent(newRow, companyId));
      } else {
        dispatch(CreateNewInvent(newRow, companyId));
      }
      onHide();
    }
  };
  const onHide = () => {
    setNewRow(emptyRow);
    setErrors({});
    onClose();
  };

  return (
    <Modal size="small" closeIcon onClose={onHide} open={open}>
      <Modal.Header> {!updateRow ? t("create_new_item") : t("update_item")}</Modal.Header>
      <Modal.Content>
        <Form onSubmit={onSubmit}>
          <Form.Group>
            <Form.Field required width={5}>
              <label>{t("itemid")}</label>
              <Form.Input
                maxLength={20}
                autoFocus={!updateRow}
                placeholder={t("itemid")}
                required
                name="itemId"
                value={newRow.itemId === undefined || newRow.itemId === null ? "" : newRow.itemId}
                onChange={onInputChange}
                disabled={updateRow}
                error={errors.itemId ? {content: errors.itemId} : false}
              />
            </Form.Field>
            <Form.Field width={11}>
              <label>{t("itemname")}</label>
              <Form.Input
                autoFocus={updateRow}
                maxLength={50}
                placeholder={t("itemname")}
                name="itemName"
                value={newRow.itemName === undefined || newRow.itemName === null ? "" : newRow.itemName}
                onChange={onInputChange}
                error={errors.itemName ? {content: errors.itemName} : false}
              />
            </Form.Field>
          </Form.Group>

          <Form.Group widths={"equal"}>
            <InputEAN label={t("ean14_pcs")} error={errors.ean14} ean={newRow.ean14 !== undefined && newRow.ean14 !== null ? newRow.ean14.trim() : ""} name={"ean14"} onInputChange={onInputChange} />
            <InputEAN label={t("ean14_box")} error={errors.ean14Box} ean={newRow.ean14Box !== undefined && newRow.ean14Box !== null ? newRow.ean14Box.trim() : ""} name={"ean14Box"} onInputChange={onInputChange} />
            <InputEAN label={t("ean14_pallet")} error={errors.ean14Pallet} ean={newRow.ean14Pallet !== undefined && newRow.ean14Pallet !== null ? newRow.ean14Pallet.trim() : ""} name={"ean14Pallet"} onInputChange={onInputChange} />
          </Form.Group>
          <Form.Group widths={"equal"}>
            <Form.Field>
              <label>{t("qty_box")}</label>
              <Form.Input
                placeholder={"0"}
                name="qtyBox"
                value={newRow.qtyBox === undefined || newRow.qtyBox === null ? "" : newRow.qtyBox}
                onChange={onInputChange}
                error={errors.qtyBox ? {content: errors.qtyBox} : false}
                pattern="\d*"
                inputMode="numeric"
              />
            </Form.Field>
            <Form.Field>
              <label>{t("qty_pallet")}</label>
              <Form.Input
                placeholder={"0"}
                name="qtyPallet"
                value={newRow.qtyPallet === undefined || newRow.qtyPallet === null ? "" : newRow.qtyPallet}
                onChange={onInputChange}
                error={errors.qtyPallet ? {content: errors.qtyPallet} : false}
              />
            </Form.Field>
          </Form.Group>

          <Form.Group widths={"equal"}>
            <Form.Field>
              <label>{t("net_weight_pcs")}</label>
              <Form.Input
                placeholder={"0.000"}
                name="netWeight"
                onBlur={handleBlur}
                value={newRow.netWeight === undefined || newRow.netWeight === null ? "" : newRow.netWeight}
                onChange={onInputChange}
                error={errors.netWeight ? {content: errors.netWeight} : false}
              />
            </Form.Field>
            <Form.Field>
              <label>{t("brutto_weight_pcs")}</label>
              <Form.Input
                placeholder={"0.000"}
                name="bruttoWeight"
                onBlur={handleBlur}
                value={newRow.bruttoWeight === undefined || newRow.bruttoWeight === null ? "" : newRow.bruttoWeight}
                onChange={onInputChange}
                error={errors.bruttoWeight ? {content: errors.bruttoWeight} : false}
              />
            </Form.Field>
          </Form.Group>

          <Form.Group widths={"equal"}>
            <Form.Field>
              <label>{t("brutto_weight_box")}</label>
              <Form.Input
                placeholder={"0.000"}
                name="bruttoWeightBox"
                onBlur={handleBlur}
                value={newRow.bruttoWeightBox === undefined || newRow.bruttoWeightBox === null ? "" : newRow.bruttoWeightBox}
                onChange={onInputChange}
                error={errors.bruttoWeightBox ? {content: errors.bruttoWeightBox} : false}
              />
            </Form.Field>
            <Form.Field>
              <label>{t("brutto_weight_pallet")}</label>
              <Form.Input
                placeholder={"0.000"}
                name="bruttoWeightPallet"
                onBlur={handleBlur}
                value={newRow.bruttoWeightPallet === undefined || newRow.bruttoWeightPallet === null ? "" : newRow.bruttoWeightPallet}
                onChange={onInputChange}
                error={errors.bruttoWeightPallet ? {content: errors.bruttoWeightPallet} : false}
              />
            </Form.Field>
          </Form.Group>

          <Form.Group widths={"equal"}>
            <Form.Field>
              <label>{t("days_best_before")}</label>
              <Form.Input placeholder={"0"} name="daysBb" value={newRow.daysBb === undefined || newRow.daysBb === null ? "" : newRow.daysBb} onChange={onInputChange} error={errors.daysBb ? {content: errors.daysBb} : false} />
            </Form.Field>
            <Form.Field>
              <label>{t("days_expiry")}</label>
              <Form.Input
                placeholder={"0"}
                name="daysExp"
                value={newRow.daysExp === undefined || newRow.daysExp === null ? "" : newRow.daysExp}
                onChange={onInputChange}
                error={errors.daysExp ? {content: errors.daysExp} : false}
              />
            </Form.Field>
          </Form.Group>

          <Form.Group widths={"equal"}>
            <Form.Field>
              <label>AI 90</label>
              <Form.Input
                placeholder={"AI90"}
                maxLength={20}
                name="ai90"
                value={newRow.ai90 === undefined || newRow.ai90 === null ? "" : newRow.ai90}
                onChange={onInputChange}
                error={errors.ai90 ? {content: errors.ai90} : false}
              />
            </Form.Field>
            <Form.Field>
              <label>AI 91</label>
              <Form.Input
                placeholder={"AI91"}
                maxLength={20}
                name="ai91"
                value={newRow.ai91 === undefined || newRow.ai91 === null ? "" : newRow.ai91}
                onChange={onInputChange}
                error={errors.ai91 ? {content: errors.ai91} : false}
              />
            </Form.Field>
            <Form.Field>
              <label>AI 92</label>
              <Form.Input
                placeholder={"AI92"}
                maxLength={20}
                name="ai92"
                value={newRow.ai92 === undefined || newRow.ai92 === null ? "" : newRow.ai92}
                onChange={onInputChange}
                error={errors.ai92 ? {content: errors.ai92} : false}
              />
            </Form.Field>
          </Form.Group>
          <Form.Field>
            <label>{t("other_info")}</label>
            <Form.Input placeholder={t("other_info")} name="other" value={newRow.other === undefined || newRow.other === null ? "" : newRow.other} onChange={onInputChange} />
          </Form.Field>
          <button type="submit" style={{display: "none"}} aria-hidden="true"></button>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button color="black" basic onClick={onHide}>
          {t("cancel_btn")}
        </Button>
        <Button color="green" basic type="submit" onClick={onSubmit}>
          {!updateRow ? t("create_btn") : t("update_btn")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const emptyRow: IInventTable = {
  itemId: "",
  companyId: 0,
};
